define('plugin/membership/view/MembershipItemView',['require','lib/view/LayoutView','view/helper/DatePicker','lib/theme/ThemeSettings'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var DatePicker = require('view/helper/DatePicker');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Membership item view
     *
     * @class MembershipItemView
     */
    return LayoutView.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#membership_item_view_list';
            }
            return '#membership_item_view';
        },
        ui: {
            'cancelBtn': '.sb_cancel_recurring',
            'startDateInput': '.sb_start_date'
        },
        triggers: {
            'click @ui.cancelBtn': 'recurringCancel'
        },
        events: {
            'change @ui.startDateInput': 'setStartDate'
        },
        _startDateValue: null,
        _attached: false,
        _datepicker: null,

        initialize: function () {
            if (this.model.get('fixed_start_date')) {
                this._startDateValue = this.model.get('fixed_start_date');
            } else if (this.model.get('period_end') && this.model.get('can_be_used')) {
                this._startDateValue = this.model.get('period_end');
            } else {
                this._startDateValue = new Date().getMysqlDate();
            }

            this.serviceCollection = this.getOption('serviceCollection');
        },

        setStartDate: function (event, b) {
            if (this._datepicker) {
                this._datepicker.datepicker('destroy');
                this._datepicker = null;

                this._startDateValue = this.ui.startDateInput.val();
                this.render();
            }
        },

        onRender: function () {
            if (this.ui.startDateInput) {
                this._datepicker = DatePicker.initDatepicker(this.ui.startDateInput, {
                    'startDate': new Date()
                });
            }
        },

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);

            if (data.period_start) {
                data.period_start = Date.parseMysqlDate(data.period_start);
            }
            if (data.period_end) {
                data.period_end = Date.parseMysqlDate(data.period_end);
            }
            if (data.next_payment_date) {
                data.next_payment_date = Date.parseMysqlDate(data.next_payment_date);
            }
            if (data.last_payment_date) {
                data.last_payment_date = Date.parseMysqlDate(data.last_payment_date);
            }
            data.allowed_to_buy = parseInt(data.is_active) === 1 && parseInt(data.is_visible) === 1;
            data.highlighted = this.getOption('highlighted');
            data.is_fixed_start_date = !!this.model.get('fixed_start_date');
            data.fixed_start_date = this.model.get('fixed_start_date');
            data.start_date = this._startDateValue;

            if (this.serviceCollection) {
                var serviceIds = this.model.get('services');

                if(this.model.get('services') === undefined && this.model.get('membership')){
                    serviceIds = this.model.get('membership').services;
                }

                if(!serviceIds){
                    serviceIds = [];
                }
                data.services = [];
                this.serviceCollection.each(function (service) {
                    if (serviceIds.indexOf(service.get('id')) !== -1) {
                        data.services.push(service.toJSON());
                    }
                });
            }

            //console.log(data.services, this.serviceCollection);

            return data;
        }

    });

});
